import { getWeb3 } from 'utils/get-web3';

const blockheight = async chainId => {
	const web3 = getWeb3(chainId);
	const blockheight = await web3.eth.getBlockNumber();
	return blockheight;
};

export default blockheight;
